import React from 'react';
import { UsersCard } from 'entities/users/ui/UsersCard';
import { Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCreateUsersDefaultValues } from 'entities/users/lib/hooks/useCreateUsersDefaultValues';
import { useCreateUsersMPMutation } from 'entities/users/api';
import { DataUserMPFormType, ErrorCreateUserResponse } from 'entities/users/types';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useDispatch } from 'react-redux';
import { transformDataUserMP } from 'entities/users/lib';
import { validationSchemaCreateUserData } from 'entities/users/model';

export const CreateUsersCard = () => {
  const dispatch = useDispatch();
  const defaultValues = useCreateUsersDefaultValues();
  const [createUserMPRequest] = useCreateUsersMPMutation();

  const form = useForm<DataUserMPFormType>({
    resolver: yupResolver(validationSchemaCreateUserData) as Resolver<DataUserMPFormType>,
    defaultValues,
  });

  const onSubmit: SubmitHandler<DataUserMPFormType> = (data) => {
    const { setError } = form;
    createUserMPRequest({ data: transformDataUserMP(data) }).then((res) => {
      const { error } = res as ErrorCreateUserResponse;
      if (error) {
        if (error.status === 422) {
          error.data.errors.map(({ msg, loc }) => {
            loc.map((err) => {
              setError(`${err}`, { message: msg });
            });
          });
        }
      } else {
        dispatch(setDrawerOpen(false));
      }
    });
  };

  return (
    <UsersCard
      title="Создать пользователя"
      form={form}
      textButton="Создать"
      onSubmit={onSubmit}
    />
  );
};
